import { jsx as _jsx } from "react/jsx-runtime";
import { InputList } from '@vertesia/ui/core';
import { useEffect, useState } from 'react';
export function StringListFacet({ search, name, placeholder, className }) {
    const [tags, setTags] = useState([]);
    useEffect(() => {
        search.setFilterValue(name, tags);
    }, [tags]);
    return (_jsx(InputList, { className: className, value: tags, onChange: setTags, placeholder: placeholder }));
}
//# sourceMappingURL=StringListFacet.js.map